import { DeleteRowConfirmationDialog } from "@/components/ax/dataTable/DeleteRowConfirmationDialog";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { showSuccess, showApiError } from "@/lib/toast";
import { deleteUser } from "@/sideEffects/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  userId: number;
}

export const DeleteUserButton: React.FC<Props> = ({ userId }) => {
  const { t } = useTranslation();

  const { goToUser } = useAppNavigate();
  const queryClient = useQueryClient();
  const deleteUserMutation = useMutation({
    mutationFn: () => deleteUser(userId),
    onSuccess: () => {
      showSuccess(t("common.deletedSuccess"));
      goToUser();

      // Give queryClient time to invalidate queries, otherwise it doesn't work
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: ["getUser"],
        });
        queryClient.invalidateQueries({
          queryKey: ["getUserDetails", userId],
        });
      }, 1000);
    },
    onError: showApiError,
  });

  return (
    <DeleteRowConfirmationDialog
      onConfirmDelete={() => deleteUserMutation.mutate()}
      isLoading={deleteUserMutation.isPending}
    />
  );
};
